/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCouponInfoRespVo
 */
export interface UserCouponInfoRespVo {
    /**
     * 数据编号
     * @type {number}
     * @memberof UserCouponInfoRespVo
     */
    id?: number;
    /**
     * 用户编号
     * @type {number}
     * @memberof UserCouponInfoRespVo
     */
    userId?: number;
    /**
     * 优惠券名称，必传
     * @type {string}
     * @memberof UserCouponInfoRespVo
     */
    name?: string;
    /**
     * 有效期开始时间
     * @type {string}
     * @memberof UserCouponInfoRespVo
     */
    beginTime?: string;
    /**
     * 有效期结束时间
     * @type {string}
     * @memberof UserCouponInfoRespVo
     */
    endTime?: string;
    /**
     * 货币代码，如 CNY、USD、KRW 等，必传
     * @type {string}
     * @memberof UserCouponInfoRespVo
     */
    currencyCode?: string;
    /**
     * 优惠券金额，字符串类型，支持小数，必传
     * @type {string}
     * @memberof UserCouponInfoRespVo
     */
    amount?: string;
    /**
     * 是否可转让：0-不可转让，1-可转让，必传
     * @type {number}
     * @memberof UserCouponInfoRespVo
     */
    canTrans?: number;
    /**
     * 优惠券作用于的附加服务 ID 列表，JSON 数组格式，如  [1,2,3,4] 可选
     * @type {Array<number>}
     * @memberof UserCouponInfoRespVo
     */
    additionalServiceIds?: Array<number>;
    /**
     * 优惠券发放数量，必须大于 0，必传
     * @type {number}
     * @memberof UserCouponInfoRespVo
     */
    number?: number;
    /**
     * 优惠券来源：1-系统发放，2-其他用户转来，必传
     * @type {number}
     * @memberof UserCouponInfoRespVo
     */
    source?: number;
    /**
     * 源用户 ID，当来源为 2（其他用户转来）时必填，可选
     * @type {number}
     * @memberof UserCouponInfoRespVo
     */
    sourceUserId?: number;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof UserCouponInfoRespVo
     */
    enable?: number;
    /**
     * 使用状态 1待使用 2已使用 3已过期 4已退回；不可用看 enable 字段
     * @type {number}
     * @memberof UserCouponInfoRespVo
     */
    userCouponStatus?: number;
    /**
     * 发放方式 1 管理员发放，2 活动发放
     * @type {number}
     * @memberof UserCouponInfoRespVo
     */
    grantType?: number;
    /**
     * 用户名
     * @type {string}
     * @memberof UserCouponInfoRespVo
     */
    userName?: string;
    /**
     * 用户编码
     * @type {string}
     * @memberof UserCouponInfoRespVo
     */
    userCode?: string;
    /**
     * 优惠券作用于的附加服务名称
     * @type {string}
     * @memberof UserCouponInfoRespVo
     */
    additionalServiceIdDesc?: string;
    /**
     * 优惠卷是否长期 long_term 1是 0否
     * @type {number}
     * @memberof UserCouponInfoRespVo
     */
    longTerm?: number;
    /**
     * 领取时间
     * @type {string}
     * @memberof UserCouponInfoRespVo
     */
    createTime?: string;
    /**
     * 使用时间
     * @type {string}
     * @memberof UserCouponInfoRespVo
     */
    useTime?: string;
}

/**
 * Check if a given object implements the UserCouponInfoRespVo interface.
 */
export function instanceOfUserCouponInfoRespVo(value: object): value is UserCouponInfoRespVo {
    return true;
}

export function UserCouponInfoRespVoFromJSON(json: any): UserCouponInfoRespVo {
    return UserCouponInfoRespVoFromJSONTyped(json, false);
}

export function UserCouponInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCouponInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'name': json['name'] == null ? undefined : json['name'],
        'beginTime': json['beginTime'] == null ? undefined : json['beginTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'canTrans': json['canTrans'] == null ? undefined : json['canTrans'],
        'additionalServiceIds': json['additionalServiceIds'] == null ? undefined : json['additionalServiceIds'],
        'number': json['number'] == null ? undefined : json['number'],
        'source': json['source'] == null ? undefined : json['source'],
        'sourceUserId': json['sourceUserId'] == null ? undefined : json['sourceUserId'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'userCouponStatus': json['userCouponStatus'] == null ? undefined : json['userCouponStatus'],
        'grantType': json['grantType'] == null ? undefined : json['grantType'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'additionalServiceIdDesc': json['additionalServiceIdDesc'] == null ? undefined : json['additionalServiceIdDesc'],
        'longTerm': json['longTerm'] == null ? undefined : json['longTerm'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'useTime': json['useTime'] == null ? undefined : json['useTime'],
    };
}

export function UserCouponInfoRespVoToJSON(json: any): UserCouponInfoRespVo {
    return UserCouponInfoRespVoToJSONTyped(json, false);
}

export function UserCouponInfoRespVoToJSONTyped(value?: UserCouponInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'name': value['name'],
        'beginTime': value['beginTime'],
        'endTime': value['endTime'],
        'currencyCode': value['currencyCode'],
        'amount': value['amount'],
        'canTrans': value['canTrans'],
        'additionalServiceIds': value['additionalServiceIds'],
        'number': value['number'],
        'source': value['source'],
        'sourceUserId': value['sourceUserId'],
        'enable': value['enable'],
        'userCouponStatus': value['userCouponStatus'],
        'grantType': value['grantType'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'additionalServiceIdDesc': value['additionalServiceIdDesc'],
        'longTerm': value['longTerm'],
        'createTime': value['createTime'],
        'useTime': value['useTime'],
    };
}

